const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const MOBILE_REGEX = /^[6-9]\d{9}$/;
const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[ !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]).{8,64}$/;

export const isEmail = (value) => EMAIL_REGEX.test(value.trim());
export const isMobile = (value) => MOBILE_REGEX.test(value.trim());

export const validateSignupForm = ({ name, email, phone, password }) => {
  const errors = {};

  if (!name.trim()) {
    errors.name = "Name is required.";
  } else if (name.trim().length < 2 || name.trim().length > 60) {
    errors.name = "Name must be between 2 and 60 characters.";
  }

  if (!email.trim()) {
    errors.email = "Email is required.";
  } else if (!isEmail(email)) {
    errors.email = "Enter a valid email address.";
  }

  if (!password) {
    errors.password = "Password is required.";
  } else if (!PASSWORD_REGEX.test(password)) {
    errors.password =
      "Use 8+ chars with uppercase, lowercase, number, and special character.";
  }

  return errors;
};

export const validateLoginForm = ({ email, otp, name, isExistingUser }) => {
  const errors = {};
  const normalizedEmail = email.trim();

  if (!normalizedEmail) {
    errors.email = "Email is required.";
  } else if (!isEmail(normalizedEmail)) {
    errors.email = "Enter a valid email address.";
  }

  if (!isExistingUser) {
    if (!name.trim()) {
      errors.name = "Name is required.";
    } else if (name.trim().length < 2 || name.trim().length > 60) {
      errors.name = "Name must be between 2 and 60 characters.";
    }
  }

  if (!otp.trim()) {
    errors.otp = "OTP is required.";
  } else if (!/^\d{6}$/.test(otp.trim())) {
    errors.otp = "OTP must be 6 digits.";
  }

  return errors;
};

export const validateAdminLoginForm = ({ email }) => {
  const errors = {};

  if (!email.trim()) {
    errors.email = "Email is required.";
  } else if (!isEmail(email)) {
    errors.email = "Enter a valid admin email address.";
  }

  return errors;
};

export const validateForgotPasswordForm = ({ email, otp }) => {
  const errors = {};

  if (!email.trim()) {
    errors.email = "Email is required.";
  } else if (!isEmail(email)) {
    errors.email = "Enter a valid email address.";
  }

  if (!otp.trim()) {
    errors.otp = "OTP is required.";
  } else if (!/^\d{6}$/.test(otp.trim())) {
    errors.otp = "OTP must be 6 digits.";
  }

  return errors;
};

export const validateResetPasswordForm = ({ password, confirmPassword }) => {
  const errors = {};

  if (!password) {
    errors.password = "New password is required.";
  } else if (!PASSWORD_REGEX.test(password)) {
    errors.password =
      "Use 8+ chars with uppercase, lowercase, number, and special character.";
  }

  if (!confirmPassword) {
    errors.confirmPassword = "Please confirm your password.";
  } else if (password !== confirmPassword) {
    errors.confirmPassword = "Passwords do not match.";
  }

  return errors;
};
